export default __webpack_public_path__ + "9957e399bc1e616d1aece14e0e3f8d21.svg";